import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configurePromptLibraryHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}

function client() {
  if (http === null) throw new Error('configurePromptLibraryHttp must be called before prompt library API use')
  return http
}

export async function listPrompts(query) {
  return client().get('/prompts', { query, routeId: 'visualGame.promptLibrary.list' })
}

export async function getPrompt(id) {
  return client().get(`/prompts/${encodeURIComponent(id)}`, { routeId: 'visualGame.promptLibrary.detail' })
}

export async function reviewPrompt(id, quality) {
  return client().post(`/prompts/${encodeURIComponent(id)}/review`, { body: { quality }, routeId: 'visualGame.promptLibrary.review' })
}

/** R1 检索召回测试：给一段文本，返回按相似度排好序的已批准提示词。 */
export async function recallPrompts(body) {
  return client().post('/prompts/recall', { body, routeId: 'visualGame.promptLibrary.recall' })
}
